import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { appApiResources } from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class ReceiptSearchService {

  constructor(private http: HttpClient) { }

  async receiptSearch(query) {
    try {
      // const httpOptions = {
      //   headers: new HttpHeaders({
      //     "Content-Type": "application/json",
      //     Authorization: `jwt ${idToken}`
      //   })
      // }; 
      console.log
      let response = await this.http
        .get(`${appApiResources.receiptSearch}?offering_type_id=${query.offerType}&bank_id=${query.bank}&from_date=${query.fromDate}&end_date=${query.toDate}&mode_id=${query.mode}&amt_greater=${query.amtGreater}&amt_lesser=${query.amtLesser}&event_id=${query.receiptEvent}&event_offering_type_id=${query.offeringTypeEventBased}`)
        .toPromise();
      return response;
    } catch (error) {
      return error;
    }
  }
}